<template>
  <form>
    <hr />
    <b-row>
      <b-col cols="12">
        <label class="label-leyes">
          <span class="label-leyes-span">Nº Ley</span>
          <i
            class="bx bxs-trash"
            @click="removeItem(objTest)"
            style="color:#24c6ab; cursor: pointer;"
          ></i
        ></label>
        <b-form-input
          v-model="objTest.nLey"
          class="input-leyes"
          type="text"
          :disabled="readOnly"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6">
        <label class="label-leyes">
          <span class="label-leyes-span">Fecha de Promulgación</span>
        </label>
        <b-form-datepicker
          class="input-leyes"
          :id="`datepicker-prom-${index}`"
          :hide-header="true"
          locale="es"
          :disabled="readOnly"
          v-model="objTest.fechaPromulgacion"
        ></b-form-datepicker>
      </b-col>
      <b-col cols="6">
        <label class="label-leyes">
          <span class="label-leyes-span">Fecha de Entrada en Vigencia</span>
        </label>
        <b-form-datepicker
          class="input-leyes"
          :id="`datepicker-vigencia-${index}`"
          :hide-header="true"
          locale="es"
          :disabled="readOnly"
          v-model="objTest.fechaIngresoVigencia"
        ></b-form-datepicker>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <label class="label-leyes">
          <span class="label-leyes-span">Materia</span>
        </label>
        <b-form-textarea
          v-model="objTest.materia"
          class="input-leyes"
          type="text"
          :disabled="readOnly"
        />
      </b-col>
    </b-row>
  </form>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  props: ["objTest", "removeItem", "index", "readOnly"],
};
</script>

<style scoped>
.label-leyes {
  font-weight: bold;
}

.label-leyes-span {
  font-size: 16px;
  margin-right: 5px;
}
.input-leyes {
  width: 100% !important;
  margin-bottom: 20px;
  border: none;
  border: 1px solid #ccc;
}

.input-leyes:focus {
  border: #24c6ab;
}
</style>
